import React from 'react';
import classNames from 'classnames';
import { IconButton } from '@material-ui/core';
import { PERIOD_SCALE_ENUM } from '~/modules/common/charts/timeline/periodScale';
import {
  getUserPreferenceWeekStart,
  getUserPreferenceWeekEnd
} from '~/modules/common/dates/dayOfWeek';

/**
 * Generates picker props for different date scales (weeks, months, years)
 * @param {Object} me - User context object
 * @param {string} scale - The period scale (days, weeks, months, quarters, years)
 * @param {Object} classes - CSS classes for styling
 * @returns {Object} Props to be passed to the DatePicker component
 */
export const getPickerProps = (me, scale, classes) => {
  if (scale === PERIOD_SCALE_ENUM.WEEKS) {
    return {
      renderDay: (date, selectedDate, dayInCurrentMonth) => {
        const start = getUserPreferenceWeekStart(me, selectedDate);
        const end = getUserPreferenceWeekEnd(me, selectedDate);
        const isFirstDay = date.hasSame(start, 'day');
        const isLastDay = date.hasSame(end, 'day');

        const dayIsBetween = date >= start && date <= end;

        const wrapperClassName = classNames({
          [classes.highlight]: dayIsBetween,
          [classes.firstHighlight]: isFirstDay,
          [classes.endHighlight]: isLastDay
        });

        const dayClassName = classNames(classes.day, {
          [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
          [classes.highlightNonCurrentMonthDay]:
            !dayInCurrentMonth && dayIsBetween
        });

        return (
          <div className={wrapperClassName}>
            <IconButton className={dayClassName}>
              <span> {date.toFormat('d')} </span>
            </IconButton>
          </div>
        );
      }
    };
  }
  if (scale === PERIOD_SCALE_ENUM.MONTHS) {
    return {
      views: ['year', 'month'],
      openTo: 'month'
    };
  }
  if (scale === PERIOD_SCALE_ENUM.YEARS) {
    return {
      views: ['year'],
      openTo: 'year'
    };
  }

  return {};
};
